<template>
  <el-col align="left">
    <popup
       buttonStyle="primary"
       heading="New Category"
       :showText="showText"
       buttonText="Category"
       :centerButton="true"
       buttonIcon="fa fa-file"
       button-size="mini"
       @save="onSaveDialog"
       @close="onCloseDialog">

      <el-form ref="ff" :model="file" :inline="false" :label-position="labelPos">

        <select-input v-if="titleList" v-model="file.title" prop="title" label="Title" :list="titleList" :disabled="!editing" />
        <text-input v-else v-model="file.title" prop="title" label="Title" placeholder="Title in the files listing" :disabled="!editing" />

        <text-input v-if="showCaption" v-model="file.caption" prop="caption" label="Caption" placeholder="If empty file name will be used" :disabled="!editing" />
        <text-input v-if="showRef" v-model="file.ref" prop="ref" label="Ref" placeholder="Any file ref (optional)" :disabled="!editing" />

      </el-form>

      <el-form v-if="isTowerCo() && isManager('project')" ref="ff2" :model="file" :inline="false" :label-position="labelPos">

        <select-input v-if="partyList" v-model="file.partyNo" prop="partyNo" label="Party" :list="partyList" :disabled="!editing" />
        <select-input v-if="stepList" v-model="file.step" prop="step" label="Step" :list="stepList" :disabled="!editing" />

      </el-form>

    </popup>
  </el-col>

</template>


<script>
import Vue from 'vue'
import VueEvents from 'vue-events'

Vue.use(VueEvents)

import ArrayMixins from '@/mixins/ArrayMixins'
import PostMixins from '@/mixins/PostMixins'


export default {
  mixins: [ArrayMixins, PostMixins],

  props: {
    copyExisting: {
      type: Object,
      default: null
    },
    titleList: {
      type: Array,
      default: null
    },
    partyList: {
      type: Array,
      default: null
    },
    stepList: {
      type: Array,
      default: null
    },
    showText: {
      type: Boolean,
      default: true
    },
    showCaption: {
      type: Boolean,
      default: true
    },
    showRef: {
      type: Boolean,
      default: true
    },
    labelPos: {
      type: String,
      default: 'left'
    },
    editMode: {
      type: Boolean,
      default: true
    },
    tableRef: {
      type: String,
      default: 'filestable'
    }
  },

  methods: {
    success () {
      this.$events.fire(this.tableRef + '-refresh-table')
      this.file.title = null
      this.file.caption = null
    },

    onSaveDialog () {

      if (this.existing) {
        this.file = this.copy(this.existing, this.file)
      }

      this.saveForm(this, '/file', null, this.file, 'File Category: ' + this.file.title, this.success)
    },

    onCloseDialog () {

    }

  },

  computed: {
    uniqueTableRef: function () {
      return this.tableRef + '-' + (this.existing.partyNo ? this.existing.partyNo : '')
    }
  },

  watch: {
    copyExisting (value) {
      this.existing = value
    }
  },

  data () {
    return {
      existing: this.copyExisting,
      editing: this.editMode,
      file: this.getTableStruct('files')
    }
  }
}

</script>



// WEBPACK FOOTER //
// FileAction.vue?26e94827